$(document).ready(function () {
  $(".btn-toggle-menu").click(function () {
    let wheight = $(window).height() - $("#shopify-section-header").height();
    let paddingnav = $("#shopify-section-header").height();
    $("body").toggleClass("no-scroll")
    $("[data-section-id=header]").toggleClass("menunav-opened");
    $(".menunav-custom").toggleClass("nav-active");
    $(".site-header").toggleClass("header-transparent");
    $(".nav-wrapper").css("max-height", wheight + "px");
    $(".menunav-custom").css("padding-top", paddingnav + "px")
    $(".text-toggle").toggleClass("hide");
    $(".icon-toggle").toggleClass("hide");
    $(".login-cart").toggleClass("hide")
  })

  if ($(".template-product").length) {
    let formproduct = $(".product-form").outerHeight();
    console.log(formproduct)
    $(".site-footer").css("margin-bottom", formproduct + "px");
  }

  $(".site-nav--has-dropdown").click(function () {
    $(this).toggleClass("site-nav--active-dropdown")
  })

  // console.log(parseInt($('.slideshow-owl').attr('data-autoplaytimeout')) * 1000)

  if ($('.slideshow-owl').length) {
    $('.slideshow-owl').owlCarousel({
      loop: true,
      // nav: true,
      dots: true,
      items: 1,
      autoplay: false,
      autoplayTimeout: parseInt($('.slideshow-owl').attr('data-autoplaytimeout')) * 1000,
      autoplayHoverPause: true,
      // navText: ['PREV', 'NEXT'],
      // onInitialized: appendOwlNavDivider,
    });
  }

  function appendOwlNavDivider(event) {
    const slider = $(event.target);
    const navPrev = slider.find('.owl-nav .owl-prev');
    const divider = '<div class="nav-divider"></div>';

    navPrev.after(divider);
  }

  if ($('.slider-product-owl').length) {
    $('.slider-product-owl').owlCarousel({
      loop: false,
      nav: false,
      dots: true,
      items: 1
    });
  }

  $('button.js-mobile-nav-toggle').click(function () {
    let header = $('header.site-header');
    if ($(this).hasClass('mobile-nav--open')) {
      header.addClass('nav--open');
    } else {
      header.removeClass('nav--open');
    }
  });

  if ($(".template-index").length) {
    let heightHead = $("#shopify-section-header").height() + 1;
    $(".page-container").css("margin-top", "-" + heightHead + "px");
    // $(".page-container").css("margin-top", "0px");

    $(window).scroll(function () {
      let scroll = $(window).scrollTop();
      let header = $('header.site-header');
      let sticky = header.outerHeight();

      if (scroll >= sticky) {
        header.removeClass("header-transparent");
      } else {
        header.addClass("header-transparent");
      }
    });
  }
  else {
    var headerTransparent = setInterval(function () {
      if ($(".header-transparent").length) {
        $(".site-header").removeClass("header-transparent");
        clearInterval(headerTransparent);
      }
    }, 1000);
  }

  if ($(".section-slider").length) {
    $('.section-slider .feature-list').owlCarousel({
      loop: false,
      nav: false,
      dots: true,
      items: 1
    });
  }

  if ($(".slider-instagram").length) {
    $('.slider-instagram').owlCarousel({
      loop: true,
      nav: false,
      dots: false,
      items: 4.5,
      margin: 30,
      responsive: {
        // breakpoint from 0 up
        0: {
          items: 1.5,
          margin: 10,
          center: true
        },
        // breakpoint from 768 up
        768: {
          items: 4.5
        }
      }
    });
  }
  if ($(".img-product-slider").length) {
    if (window.matchMedia('(max-width: 600px)').matches) {
      $('.img-product-slider').owlCarousel({
        loop: true,
        nav: false,
        dots: true,
        items: 1
      });
    }
  }

  $(".img-pass").click(function () {
    if ($(".field-pass input[type=password]").length) {
      $(".field-pass input").attr("type", "text")
    }
    else {
      $(".field-pass input").attr("type", "password")
    }

    $(".img-pass").toggleClass("hide")
  })

  $('#blogFilter').change(function (e) {
    let optionSelected = $(this);
    let valueSelected = optionSelected.val();
    setTimeout(() => {
      window.location.href = valueSelected;
    }, 500);
  })

  // handle register
  $('#button-submit-register').click(function () {
  //   let name = $('#RegisterForm-YourName').val().trim();

  //   // kalau kosong → kosongkan semua
  //   if (name === '') {
  //     $('#RegisterForm-FirstName').val('');
  //     $('#RegisterForm-LastName').val('');
  //   } else {
  //     // pecah berdasarkan spasi pertama saja
  //     let parts = name.split(/ (.+)/); // pecah jadi [first, sisanya]

  //     let first_name = parts[0] ? parts[0].trim() : '';
  //     let last_name = parts[1] ? parts[1].trim() : '';

  //     $('#RegisterForm-FirstName').val(first_name);
  //     $('#RegisterForm-LastName').val(last_name);
  //   }

    $('#RegisterForm').submit();
  })

  // handle accordion product form
  $(".product-accordion-header").on("click", function () {
    const parentAccordion = $(this).closest(".product-accordion");
    const content = $(this).next();

    parentAccordion.find(".product-accordion-content").not($(this).next()).each(function () {
      $(this).animate({ height: 0 }, 300);
      $(this).removeClass('active')
      $(this).closest(".product-accordion").find('.product-accordion-header').removeClass('active')
    });

    if (content.height() === 0) {
      const contentHeight = parseInt(content.prop("scrollHeight")) + 40;
      content.animate({ height: contentHeight }, 300);
      content.addClass('active')
      $(this).addClass('active')
    } else {
      content.animate({ height: 0 }, 300);
      content.removeClass('active')
      $(this).removeClass('active')
    }
  });

  // page catalog-2
  if ($('.catalog-product-item').length) {
    $('.catalog-product-item').each(function(i, group){
      let $for = $(group).find('.catalog-product-image-list');
      let $nav = $(group).find('.catalog-product-image-nav-list');

      $for.slick({
        slidesToShow: 1,
        arrows: false,
        fade: true,
        asNavFor: $nav
      });

      $nav.slick({
        slidesToShow: 4,
        asNavFor: $for,
        focusOnSelect: true,
        // centerMode: true,
        arrows: false,
        vertical: true,
        verticalSwiping: true
      });

      $for.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        // Pause semua video di slide lama
        $(slick.$slides[currentSlide]).find('video').each(function() {
          this.pause();
        });
      });

      $(window).on('scroll resize', function() {
        $for.find('video').each(function() {
          var $video = $(this);
          var rect = this.getBoundingClientRect();
          var isVisible = rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);

          if (isVisible) {
            // if ($video[0].paused) {
            //   $video[0].play();
            // }
          } else {
            if (!$video[0].paused) {
              $video[0].pause();
            }
          }
        });
      });
    });

    if ($('.my-audio').length) {
      let audios = $('.my-audio'); // semua audio

      $('.btn-catalog-audio').on('click', function() {
        var button = $(this);
        var audio = button.siblings('.my-audio')[0];
  
        if (audio.paused) {
          // pause semua audio lain
          audios.each(function() {
            this.pause();
            // $(this).siblings('.toggle-audio').text('Play');
          });
  
          // play audio yang dipilih
          audio.play();
          // button.text('Pause');
        } else {
          audio.pause();
          // button.text('Play');
        }
      });
    }
  }
  // end page catalog-2
});